
import { Options, Vue } from 'vue-class-component'
import liveMatchScheduleList from '@/components/Frontend/TodaysMatchScheduleList/index.vue'

@Options({
  components: {
    liveMatchScheduleList
  }
})

export default class LiveMatchScheduleListView extends Vue {}
